export default __webpack_public_path__ + "static/media/bed-icon-black.95760994.svg";